/**
 * @see https://tiptap.dev/docs/editor/extensions/nodes/emoji
 */

import type { EmojiItem } from '@tiptap/extension-emoji'
import type { Editor } from '@tiptap/react'
import type { SuggestionOptions } from '@tiptap/suggestion'
import { createSuggestionRenderer } from '../suggestionRenderer'
import { EmojiList } from './EmojiList'

const emojiSuggestion: Omit<SuggestionOptions<EmojiItem>, 'editor'> = {
  items: ({ editor, query }: { editor: Editor; query: string }) => {
    return (editor.storage.emoji.emojis as EmojiItem[])
      .filter(({ shortcodes, tags }) => {
        return (
          shortcodes.find((shortcode) =>
            shortcode.startsWith(query.toLowerCase())
          ) || tags.find((tag) => tag.startsWith(query.toLowerCase()))
        )
      })
      .slice(0, 5)
  },

  allowSpaces: false,

  render: createSuggestionRenderer(EmojiList)
}

export default emojiSuggestion
